import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { SearchService } from '../../../search/services/search.service';
import { UserService } from '../../../services/user.service';
import { MetadataService } from '../../../services/metadata.service';
import { FeatureService } from '../../../services/feature.service';

import dayjs from 'dayjs';

/**
 * Displays the memorial certificate for printing.
 */
@Component({
	selector: 'app-memorial-print',
	templateUrl: './memorial-print.component.html',
	styleUrl: './memorial-print.component.css'
})
export class MemorialPrintComponent implements OnInit {
	
	custId: string = '';
	featureId: string = 'MemorialDocViewer';

	docId!: string;
	honor_roll: boolean = false;
	fullRecordMetadata: { [key: string]: any } = {};
	dateFormatDisplay: string = 'MM/DD/YY';

	constructor(
		private route: ActivatedRoute,
		private http: HttpClient,
		private userService: UserService,
		private searchService: SearchService,
		private featureService: FeatureService,
		private metadataService: MetadataService
	) { }

	ngOnInit(): void {
		let dateTypeProperty = this.userService.user.properties.awpropertyObjectList.find(function(x: any) { return x.name === "USER_INTERFACE_DATE_TYPE"; });
		this.dateFormatDisplay = dateTypeProperty?.value || 'MM/DD/YY';
		
		this.custId = this.featureService.getCustomerId();

		this.loadCertificateAssets();

		this.docId = this.route.snapshot.paramMap.get('id')!;

		const rollParam = this.route.snapshot.queryParamMap.get('honor_roll');
		this.honor_roll = rollParam === 'true';

		this.loadCertificate();
	}

	private loadCertificateAssets(): void {
		const cssHref = `/app/aw-ui-angular/assets/custom/${this.custId}/css/${this.featureId}Certificate.css`;

		if (!document.querySelector(`link[href="${cssHref}"]`)) {
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = cssHref;
			document.head.appendChild(link);
		}
	}

	private loadCertificate(): void {
		if (this.docId) {
			this.loadRecord();
		}
	}

	loadRecord(): void {
		this.searchService.getRecord(this.docId).then(
			(response: any) => {
				this.processMetadata(response);
//				console.log(this.fullRecordMetadata);
			},
			(err: any) => {
				console.error("Failed to load product metadata", err);
			}
		);
	}

	private processMetadata(result: any, highlights?: any) {
		let hl: { [key: string]: any } = {};
		if (highlights && highlights["aw:record"]["print"]) {
			hl = highlights["aw:record"]["print"];
		}

		let productHash = result["csw:GetRecordByIdResponse"].iStoreRecord;
		let productInfo: { [key: string]: any } = {};
		let validFields = this.userService.user.properties.awfieldObjectList.filter((x: any) => { return x.isAvailable && x.isMetadata });

		for (let p = 0; p < validFields.length; p++) {
			let field = validFields[p];

			if (!productHash[field.name]) {
				continue;
			}

			productInfo[field.name] = {
				label: field.displayName,
				value: hl[field.name] ? hl[field.name] : productHash[field.name],
				maxLength: (field.isLink ? -1 : 220),
				links: null,
				name: field.name
			};

			productInfo[field.name].cleanedValue = this.metadataService.cleanValue(productInfo[field.name].value);
			productInfo[field.name].isValidCollection =
				this.metadataService.isValidFieldCollectionValue(productInfo[field.name].name, productInfo[field.name].cleanedValue);

			if (field.type == "DATE") {
				productInfo[field.name].value = dayjs(productInfo[field.name].value).format(this.dateFormatDisplay);
			}

			if (field.name == "requires") {
				productInfo[field.name].warning = true;
			}

			if (field.isLink) {
				productInfo[field.name].links = this.metadataService.linksFromString(productHash[field.name], field.name);
			} else {
				if (productInfo[field.name].value) {
					productInfo[field.name].value = productInfo[field.name].value.replace(/; /g, ';').replace(/;/g, '; ');
				}
			}
		}
		
		const normalizedData: { [key: string]: any } = {};
		for (const key in productInfo) {
		  if (productInfo.hasOwnProperty(key)) {
		    normalizedData[key] = productInfo[key].value;
		  }
		}
		
		this.fullRecordMetadata = normalizedData;
	}
}
